class UserBehaviorTracker {
  constructor() {
    this.sessionId = this.generateSessionId();
    this.events = [];
    this.startTime = Date.now();
    this.apiEndpoint = process.env.REACT_APP_API_URL || 'https://cs4cfqc7na.execute-api.us-east-1.amazonaws.com/prod';
  }

  generateSessionId() {
    return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  init() {
    this.trackEvent('session_start', {
      userAgent: navigator.userAgent,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      referrer: document.referrer,
      url: window.location.href,
      timestamp: new Date().toISOString()
    });

    // Track mouse movements (throttled)
    let mouseTimer;
    document.addEventListener('mousemove', (e) => {
      clearTimeout(mouseTimer);
      mouseTimer = setTimeout(() => {
        this.trackEvent('mouse_movement', {
          x: e.clientX,
          y: e.clientY,
          timestamp: new Date().toISOString()
        });
      }, 1000);
    });

    // Track clicks
    document.addEventListener('click', (e) => {
      this.trackEvent('click', {
        element: e.target.tagName,
        className: e.target.className,
        id: e.target.id,
        text: e.target.textContent?.substring(0, 100),
        x: e.clientX,
        y: e.clientY,
        timestamp: new Date().toISOString()
      });
    });

    // Track form interactions
    document.addEventListener('input', (e) => {
      if (e.target.type !== 'password') {
        this.trackEvent('form_interaction', {
          fieldName: e.target.name || e.target.id,
          fieldType: e.target.type,
          value: e.target.value?.substring(0, 50),
          timestamp: new Date().toISOString()
        });
      }
    });

    // Track page visibility
    document.addEventListener('visibilitychange', () => {
      this.trackEvent('visibility_change', {
        hidden: document.hidden,
        timestamp: new Date().toISOString()
      });
    });

    // Track before unload
    window.addEventListener('beforeunload', () => {
      this.trackEvent('session_end', {
        duration: Date.now() - this.startTime,
        timestamp: new Date().toISOString()
      });
      this.sendEvents();
    });

    // Send events periodically
    setInterval(() => {
      this.sendEvents();
    }, 30000); // Every 30 seconds
  }

  trackEvent(eventType, data) {
    const event = {
      sessionId: this.sessionId,
      eventType,
      data,
      timestamp: new Date().toISOString(),
      url: window.location.href
    };

    this.events.push(event);

    // Send immediately for critical events
    if (['conversion', 'purchase', 'form_submit'].includes(eventType)) {
      this.sendEvents();
    }
  }

  async sendEvents() {
    if (this.events.length === 0) return;

    const eventsToSend = [...this.events];
    this.events = [];

    try {
      await fetch(`${this.apiEndpoint}/api/analytics/track`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          events: eventsToSend
        })
      });
    } catch (error) {
      console.error('Failed to send analytics events:', error);
      // Re-add events to queue if failed
      this.events.unshift(...eventsToSend);
    }
  }

  trackConversion(type, value = 0) {
    this.trackEvent('conversion', {
      type,
      value,
      timestamp: new Date().toISOString()
    });
  }

  trackFormSubmit(formName, data) {
    this.trackEvent('form_submit', {
      formName,
      data,
      timestamp: new Date().toISOString()
    });
  }

  trackVideoPlay(videoId, position = 0) {
    this.trackEvent('video_play', {
      videoId,
      position,
      timestamp: new Date().toISOString()
    });
  }

  trackScrollDepth(depth) {
    this.trackEvent('scroll_depth', {
      depth,
      timestamp: new Date().toISOString()
    });
  }
}

export const trackUserBehavior = new UserBehaviorTracker();